(function(){
  function initReveal(){
    var els=document.querySelectorAll('.ct-reveal:not(.ct-visible)');
    if(!els.length)return;
    if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches){els.forEach(function(e){e.classList.add('ct-visible')});return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('ct-visible');io.unobserve(en.target);}})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  function initGaleria(){
    document.querySelectorAll('[data-ct-gal]').forEach(function(g){
      var main=g.querySelector('[data-ct-main]');
      g.querySelectorAll('[data-ct-thumb]').forEach(function(b){
        b.addEventListener('click',function(){
          main.src=b.getAttribute('data-src');main.alt=b.getAttribute('data-alt')||'';
          g.querySelectorAll('[data-ct-thumb]').forEach(function(x){x.setAttribute('aria-current','false')});
          b.setAttribute('aria-current','true');
        });
      });
    });
  }
  function formatMoney(cents,fmt){
    var v=(cents/100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g,'.');
    return (fmt||'${{amount_no_decimals_with_comma_separator}}').replace(/\{\{\s*\w+\s*\}\}/,v);
  }
  function initVariantes(){
    document.querySelectorAll('[data-ct-prod]').forEach(function(root){
      var dataEl=root.querySelector('[data-ct-variants]');if(!dataEl)return;
      var variants=JSON.parse(dataEl.textContent);var fmt=root.getAttribute('data-money');
      var idInput=root.querySelector('input[name="id"]');var btn=root.querySelector('[data-ct-add]');
      var price=root.querySelector('[data-ct-price]');var compare=root.querySelector('[data-ct-compare]');
      var txtAdd=btn?btn.getAttribute('data-txt'):'';var txtOut=btn?btn.getAttribute('data-out'):'';
      function update(){
        var sel=[];root.querySelectorAll('[data-ct-option]').forEach(function(f){var c=f.querySelector('input:checked');sel.push(c?c.value:null)});
        var v=variants.find(function(x){return x.options.every(function(o,i){return o===sel[i]})});
        if(!v){if(btn){btn.disabled=true;btn.textContent='No disponible'}return;}
        idInput.value=v.id;
        if(price)price.textContent=formatMoney(v.price,fmt);
        if(compare){if(v.compare_at_price&&v.compare_at_price>v.price){compare.textContent=formatMoney(v.compare_at_price,fmt);compare.hidden=false}else{compare.hidden=true}}
        if(btn){btn.disabled=!v.available;btn.textContent=v.available?txtAdd:txtOut}
        if(window.history&&window.history.replaceState){var u=new URL(window.location.href);u.searchParams.set('variant',v.id);window.history.replaceState({},'',u.toString())}
      }
      root.querySelectorAll('[data-ct-option] input').forEach(function(i){i.addEventListener('change',update)});
    });
  }
  function init(){initReveal();initGaleria();initVariantes();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
  document.addEventListener('shopify:section:load',init);
})();
